import { render, staticRenderFns } from "./Legal_Pdf.vue?vue&type=template&id=42e93142&"
import script from "./Legal_Pdf.vue?vue&type=script&lang=ts&"
export * from "./Legal_Pdf.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports